const devConfig = { baseUrl: "https://voucherapiprod.azurewebsites.net" };

export default devConfig;
